module.exports = __webpack_public_path__ + "img/links-orange.b7624df4.svg";